/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Tier discriminator for resets — namespace tier needs `namespace_id`,
 * page tier needs `scope_key`.
 */
export type ResetMyEntityFiltersPayload = {
    tier: ResetMyEntityFiltersPayload.tier;
    namespaceId?: (string | null);
    scopeKey?: (string | null);
};

export namespace ResetMyEntityFiltersPayload {

    export enum tier {
        NAMESPACE = 'namespace',
        PAGE = 'page',
    }


}

